<script lang="ts">
	let className = "";
	export { className as class };
</script>

<div class="grid grid-cols-[auto_1fr] items-center gap-4 rounded-[22px] bg-green-100 px-12 py-8 {className}">
	<span class="flex h-12 w-12 items-center justify-center rounded-full bg-green-200 text-lg font-semibold">i</span>

	<p class="text-xs">
		<slot />
	</p>
</div>
